import React from 'react';

import Conditional from '../../common/conditional';
import PDFAssociateDetails from './pdfAssociateDetails';
import PDFLogoDetails from './pdfLogoDetails';
import PDFPageDetails from './pdfPageDetails';
import PDFTitlePage from './pdfTitlePage';

import { APP_DATE_FORMAT } from '../../../utils/constants';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';
import * as auth from '../../../services/authService';

interface PDFPageProps {
	children: React.ReactNode;
	enableTitlePage?: boolean;
	enableAssociateDetails?: boolean;
	pageDetails: models.PDFPageDetailsProps;
	projectDetails: models.Project;
}

const PDFPage: React.FC<PDFPageProps> = ({
	children,
	enableAssociateDetails = true,
	enableTitlePage = false,
	pageDetails,
	projectDetails,
}): JSX.Element => {
	const { report, organisation, supervisorId, review } = projectDetails;

	const getDate = (date: string | Date): string => {
		return date ? utils.formatTime(date, APP_DATE_FORMAT) : '';
	};

	const getSupervisorDesignation = (): string => {
		const user = auth.getCurrentUser() as models.User;
		const isSupervisor: boolean = user.id === supervisorId;

		return isSupervisor ? user.designation : '';
	};

	return (
		<React.Fragment>
			<Conditional isVisible={enableTitlePage}>
				<div className="p-3 pdf-page">
					<PDFLogoDetails
						organizationName={organisation.organisationName}
						organizationLogo={organisation.organisationLogo}
					/>

					<PDFTitlePage title={pageDetails.pageTitle} />
				</div>
			</Conditional>

			<div className="p-3 pdf-page">
				<PDFLogoDetails
					organizationName={organisation.organisationName}
					organizationLogo={organisation.organisationLogo}
				/>

				<PDFPageDetails {...pageDetails} {...projectDetails} />

				<div className="pdf-page-body">{children}</div>

				<Conditional isVisible={enableAssociateDetails}>
					<PDFAssociateDetails
						inspectorName={report.creatorName}
						reviewerName={review.reviewerName}
						approverName={report.approvedByName}
						inspectionDate={getDate(report.updatedAt ?? new Date())}
						reviewDate={getDate(review.createdAt)}
						approvalDate={getDate(report.acceptedAt)}
						inspectorRole={getSupervisorDesignation()}
						approverRole={report.approvedByDesignation}
						reviewerRole={review.reviewerDesignation}
						inspectorSignature=""
						reviewerSignature={review.reviewerSignature}
						approverSignature={report.approvedBySignature}
					/>
				</Conditional>
			</div>
		</React.Fragment>
	);
};

export default PDFPage;
